import React from 'react';
import { Helmet } from 'react-helmet';
import { useConfig } from '~components/hooks';
import { useTranslation } from 'react-i18next';

import '../../scss/pages/_terms.scss';

export default function PrivacyPolicy() {
  const { t } = useTranslation();
  const getConfig = useConfig();

  return (
    <>
      <Helmet>
        <title>
          {t('CSCASE PRIVACY POLICY', {
            hostname: getConfig?.hostname,
          })}
        </title>
        <meta
          name="description"
          content={t('Read the privacy policy and full list of services', {
            hostname: getConfig?.hostname,
          })}
        />
      </Helmet>
      <div className="page-terms">
        <h1>{t('Privacy Policy')}</h1>

        <div className="terms-block">
          <div className="terms-title">
            {t('privacy_policy_date')}: 24.11.2021
          </div>

          <div>{t('privacy_policy_0_0')}</div>
          <div>{t('privacy_policy_0_1')}</div>
        </div>

        <div className="terms-block">
          <div className="terms-title">1. {t('privacy_policy_1')}</div>
          <div>{t('privacy_policy_11')}</div>
        </div>
        <div className="terms-block">
          <div className="terms-title">2. {t('privacy_policy_2_0')}</div>
          <div>
            <span>2.1</span> {t('privacy_policy_2_1')}
          </div>
          <div>
            <span>2.1.1</span> {t('privacy_policy_2_2')}
          </div>
          <div>
            <span>2.1.2</span> {t('privacy_policy_2_3')}
          </div>
          <div>
            <span>2.1.3</span> {t('privacy_policy_2_4')}
          </div>
          <div>
            <span>2.1.4</span> {t('privacy_policy_2_5')}
          </div>
          <div>
            <span>2.1.5</span> {t('privacy_policy_2_6')}
          </div>
          <div>
            <span>2.1.6</span> {t('privacy_policy_2_7')}
          </div>
          <div>
            <span>2.1.7</span> {t('privacy_policy_2_8')}
          </div>
          <div>
            <span>2.1.8</span> {t('privacy_policy_2_9')}
          </div>
        </div>
        <div className="terms-block">
          <div className="terms-title">3. {t('privacy_policy_3_0')}</div>
          <div>{t('privacy_policy_3_1')}</div>
          <div>
            <span>3.1</span> {t('privacy_policy_3_2')}
          </div>
          <div>
            <span>3.1.1</span> {t('privacy_policy_3_3')}
          </div>
          <div>
            <span>3.1.2</span> {t('privacy_policy_3_4')}
          </div>
          <div>{t('privacy_policy_3_5')}</div>
          <div>
            <span>3.2</span> {t('privacy_policy_3_6')}
          </div>
          <div>
            <span>3.3</span> {t('privacy_policy_3_7')}
          </div>
        </div>
        <div className="terms-block">
          <div className="terms-title">3. {t('privacy_policy_d3_0')}</div>
          <div>{t('privacy_policy_d3_1')}</div>
        </div>
        <div className="terms-block">
          <div className="terms-title">4. {t('privacy_policy_4_0')}</div>
          <div>
            {t('privacy_policy_4_1', { hostname: getConfig?.hostname })}
          </div>
        </div>
        <div className="terms-block">
          <div className="terms-title">5. {t('privacy_policy_5_0')}</div>
          <div>{t('privacy_policy_5_1')}</div>
          <div>{t('privacy_policy_5_2')}</div>
          <div>{t('privacy_policy_5_3')}</div>
          <div>{t('privacy_policy_5_4')}</div>
          <div>
            {t('privacy_policy_5_5', { hostname: getConfig?.hostname })}
          </div>
        </div>
        <div className="terms-block">
          <div className="terms-title">6. {t('privacy_policy_6_0')}</div>
          <div>
            {t('privacy_policy_6_1', { hostname: getConfig?.hostname })}
          </div>
        </div>
        <div className="terms-block">
          <div className="terms-title">7. {t('privacy_policy_7_0')}</div>
          <div>
            {t('privacy_policy_7_1', { hostname: getConfig?.hostname })}
          </div>
        </div>
        <div className="terms-block">
          <div className="terms-title">8. {t('privacy_policy_8_0')}</div>
          <div>{t('privacy_policy_8_1')}</div>
          <div>{t('privacy_policy_8_2')}</div>{' '}
        </div>
        <div className="terms-block">
          <div className="terms-title">9. {t('privacy_policy_9_0')}</div>
          <div>{t('privacy_policy_9_1')}</div>
          <div>
            <a
              href={`mailto:sup@${getConfig?.hostname}`}
              rel="noopener noreferrer nofollow"
              target="_blank"
              className="footer-support-mail"
            >
              {t('privacy_policy_9_2')} sup@{getConfig?.hostname}
            </a>
          </div>
          <div></div>
          <div>{t('privacy_policy_9_3')}</div>
        </div>

        {getConfig.isRU && (
          <div className="terms-block">
            <div>
              Прием и отправка платежей через АО &quot;Киви Банк&quot;
              осуществляется
              <br />
              ИП МУХА ВЛАДИМИР БОГДАНОВИЧ
              <br />
              ИНН: 614588962120
              <br />
              ОГРНИП: 321619600095864
            </div>
          </div>
        )}
      </div>
    </>
  );
}
